import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-background text-foreground font-heading">
      <Navbar />
      
      <div className="pt-32 pb-20 px-6 md:px-12 max-w-[900px] mx-auto">
        <h1 className="text-4xl md:text-5xl font-light mb-2 leading-[1.1]">Privatlivspolicy</h1>
        <p className="text-lg text-foreground/60 mb-12">Sist oppdatert: {new Date().toLocaleDateString('nb-NO')}</p>

        <div className="space-y-8 font-serif text-lg leading-relaxed text-foreground/80">
          <section>
            <h2 className="text-2xl font-light mb-4 text-foreground">1. Introduksjon</h2>
            <p>
              LYKKE NOMAD AS (heretter «vi», «oss» eller «selskapet») er forpliktet til å beskytte ditt personvern. 
              Denne privatlivspolicyen forklarer hvordan vi samler inn, bruker, oppbevarer og beskytter dine personopplysninger.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-light mb-4 text-foreground">2. Personopplysninger vi samler inn</h2>
            <p className="mb-4">Vi samler inn følgende typer personopplysninger:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Kontaktinformasjon (navn, e-postadresse, telefonnummer)</li>
              <li>Adresseinformasjon (postnummer, by, land)</li>
              <li>Informasjon om konfigurasjoner av badstuer</li>
              <li>Teknisk informasjon (IP-adresse, nettleserinformasjon)</li>
              <li>Informasjonskapsler og sporingsdata</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-light mb-4 text-foreground">3. Hvordan vi bruker dine personopplysninger</h2>
            <p className="mb-4">Vi bruker personopplysningene dine til:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Behandle dine konfigurasjoner og tilbudsforespørsler</li>
              <li>Kontakte deg angående din bestilling eller forespørsel</li>
              <li>Forbedre vår nettside og tjenester</li>
              <li>Analysere bruksdata</li>
              <li>Overholde juridiske forpliktelser</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-light mb-4 text-foreground">4. Informasjonskapsler</h2>
            <p>
              Vi bruker informasjonskapsler for å forbedre brukeropplevelsen. Du kan kontrollere informasjonkapslene gjennom 
              innstillingene i nettleseren din. Se vår {' '}
              <a href="/cookie-policy" className="underline hover:opacity-70">
                informasjonskapselpolicy
              </a>
              {' '} for mer informasjon.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-light mb-4 text-foreground">5. Sikkerhet</h2>
            <p>
              Vi implementerer sikkerhetstiltak for å beskytte dine personopplysninger mot uautorisert tilgang, 
              endring eller sletting. Vi bruker SSL-kryptering for all datasending.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-light mb-4 text-foreground">6. Dine rettigheter</h2>
            <p className="mb-4">Du har følgende rettigheter under GDPR:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Retten til tilgang til dine personopplysninger</li>
              <li>Retten til å rette feil i dine opplysninger</li>
              <li>Retten til å slette dine opplysninger</li>
              <li>Retten til å begrense behandlingen</li>
              <li>Retten til dataoverførbarhet</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-light mb-4 text-foreground">7. Kontakt oss</h2>
            <p>
              Hvis du har spørsmål om vår privatlivspolicy eller ønsker å utøve dine rettigheter, 
              vennligst kontakt oss på:{' '}
              <a href="mailto:kontakt@lykke.info" className="underline hover:opacity-70">
                kontakt@lykke.info
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-light mb-4 text-foreground">8. Endringer i denne policyen</h2>
            <p>
              Vi forbeholder oss retten til å oppdatere denne privatlivspolicyen når som helst. 
              Endringer vil bli publisert på denne siden med oppdatert dato.
            </p>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
}